import { RibGateway } from './rib-gateway.interface';

const baseUrl = 'gk/ribs';
export class HttpRibGateway implements RibGateway {
  getRibs() {
    return {
      url: baseUrl,
      method: 'GET',
    };
  }
  changeCurrentRib(args: { ribId: string }) {
    return {
      url: `${baseUrl}/${args.ribId}/current`,
      method: 'PATCH',
    };
  }
}
